import React, { useState, useEffect } from "react";
import { useParams } from "react-router";

import TeamDetail from "./TeamDetail";
import { SonicTermData } from "../../../../common/classes/SonicTerm";
import {
  fieldStateToUpdateArgs,
  validFieldState,
} from "../../../mypage/user_settings/FieldStateFunctions";

import { FieldState } from "../../../../utils/ValidationFunctions";
import { RequestState } from "../../../../utils/RequestState";
import {
  useGetTeamsAdmin,
  useUpdateTeamAdmin,
} from "../../../../utils/useTeam";

import { useAppSelector } from "../../../../redux/hooks";
import { getAuthToken } from "../../../../redux/reducers/auth";

const TeamDetailContainer: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const [fieldState, setFieldState] = useState<FieldState>();
  const [error, setError] = useState<boolean>(false);
  const [requestState, setRequestState] = useState<RequestState>(
    RequestState.Waiting
  );
  const [isLoading, setIsLoading] = useState<boolean>(true);

  const auth_token = useAppSelector(getAuthToken);

  const queryKey = {
    auth_token,
    id,
    is_jikei_request: false,
  };

  const {
    items: { teams, owners },
    isLoading: isTeamLoading,
  } = useGetTeamsAdmin(queryKey);

  const team = teams[0];
  const owner = owners[0];

  const { mutateAsync, mutateLoading } = useUpdateTeamAdmin([
    "teamAdmin",
    queryKey,
  ]);

  // MyGame
  const [games, setGames] = useState<Array<SonicTermData>>();

  const handleGames = (value: Array<SonicTermData>) => {
    setGames([...value]);
  };

  useEffect(() => {
    if (isTeamLoading) {
      setIsLoading(true);
      return;
    }

    if (team?.game) {
      setGames(team.game);
    }

    setIsLoading(false);
  }, [isTeamLoading]);

  const handleUpdate = async () => {
    if (
      auth_token &&
      id &&
      (fieldState !== undefined ||
        selectStatus !== undefined ||
        games !== undefined)
    ) {
      const update_args: { [key: string]: string | File } = {};

      if (!validFieldState("edit", ["sonic_name"], fieldState)) {
        setError(true);
        return;
      }

      setError(false);
      setRequestState(RequestState.Doing);

      fieldStateToUpdateArgs(update_args, fieldState);

      if (games && games.length > 0) {
        const gameIds: Array<string> = [];
        games.forEach((game) => gameIds.push(game.id));
        update_args["sonic_game"] = JSON.stringify(gameIds);
      } else {
        update_args["sonic_game"] = JSON.stringify([]);
      }

      if (selectStatus) {
        update_args["sonic_status"] = selectStatus;
      }

      await mutateAsync({
        auth_token,
        id,
        update: update_args,
        is_jikei_request: false,
      });

      setRequestState(RequestState.Success);
      setShowStatusMenu(false);
      setSelectStatus("");
    }
  };

  const handleInputChange = (
    value: File | string | undefined,
    name: string
  ) => {
    let f: FieldState = {};
    if (fieldState !== undefined) {
      f = fieldState;
    }

    if (value !== undefined) {
      f[name] = [value, true];
    } else {
      f[name] = ["", false];
    }
    setFieldState({ ...f });
    setRequestState(RequestState.Pending);
  };

  // status component
  const [selectStatus, setSelectStatus] = useState<string>();
  const [showStatusMenu, setShowStatusMenu] = useState<boolean>(false);

  const handleStatusMenu = () => {
    setShowStatusMenu(!showStatusMenu);
  };

  useEffect(() => {
    if (error) {
      setError(false);
    }
  }, [fieldState]);

  return (
    <TeamDetail
      error={error}
      team={team}
      owner={owner}
      isLoading={isTeamLoading || isLoading || mutateLoading}
      selectStatus={
        typeof fieldState?.["sonic_status"]?.[0] === "string"
          ? fieldState["sonic_status"][0]
          : ""
      }
      setSelectStatus={handleInputChange}
      handleUpdate={handleUpdate}
      games={games}
      handleGames={handleGames}
      showStatusMenu={showStatusMenu}
      handleStatusMenu={handleStatusMenu}
      handleInputChange={handleInputChange}
      requestState={requestState}
    />
  );
};

export default TeamDetailContainer;
